export default __webpack_public_path__ + "static/media/investcorp_logo.6f840270.png";